<template>
  <onboarding-index />
</template>

<script>
import OnboardingIndex from '../../components/Onboarding/index'
export default {
    components: {
        OnboardingIndex
    }
}
</script>

<style>

</style>